import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Page de confirmation après soumission réussie d'un rapport par un invité
 */
export default function InviteSuccessPage() {
    const { t } = useTranslation('public');

    return (
        <div className="bg-surface min-h-[calc(100vh-7rem)] flex items-center justify-center px-[20px] pb-16">
            <div className="max-w-md w-full text-center">
                <div className="bg-card rounded-[16px] shadow-lg p-[32px]">
                    {/* Icône de succès */}
                    <div className="w-20 h-20 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                        <CheckCircle2 className="h-10 w-10 text-secondary" />
                    </div>

                    <h1 className="text-[22px] font-semibold mb-3">{t('success.title')}</h1>

                    <p className="text-[14px] text-muted-foreground mb-6">{t('success.description')}</p>

                    <div className="bg-muted/50 rounded-[12px] p-[16px]">
                        <p className="text-[13px] text-muted-foreground">{t('success.canClose')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
